<template>
    <Dialog :visible="visible" @update:visible="updateVisible" header="Contas já cadastradas" @show="onShow" @hide="onHide"
        class="w-11 lg:w-8" modal>
        <div>
            <div>
                <form @submit.prevent="onSubmitBusca">
                    <Toolbar class="bg-gray-100 w-full">
                        <template #end>
                            <div class="flex gap-1">
                                <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                    class="p-button-sm" @click="loadData" />
                            </div>
                        </template>
                    </Toolbar>
                </form>

                <DataTable :value="lista" :loading="isLoading" v-model:selection="selected" selectionMode="single"
                    size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 400px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    @sort="onTableSort">

                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="id_primario" header="ID Primario" sortable></Column>
                    <Column field="id_secundario" header="ID Secundario" sortable></Column>
                    <Column field="cliente" header="Cliente" sortable></Column>
                    <Column field="provedor" header="Provedor" sortable></Column>
                    <Column field="site" header="Site/Localidade" sortable></Column>
                    <Column field="codigo_de_barras" header="Barras" sortable></Column>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                    @page="onPage">
                </Paginator>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" />
            </div>
        </div>
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import ScrollPanel from 'primevue/scrollpanel';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import Conta from '@/service/conta.js';

import ContaForm from '@/page/conta/Form.vue';
// import ContratoFormResumo from '@/page/contrato/FormResumo.vue';

import Filter from '@/utils/Filter.js';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        contas: {
            type: Array,
            default: []
        },
        error: String,
    },
    emits: ['close'],
    components: {
        Dialog,
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        ScrollPanel,
        InputGroup,
        InputGroupAddon,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,


    },
    data() {
        return {
            lista: [],
            isLoading: false,

            selected: null,

            item: null,
            visibleForm: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    methods: {
        openForm() {
            this.item = { };
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },

        onShow() {
            this.loadData();

            if(this.error) {
                this.$toast.add({
                            severity: 'error',
                            summary: 'Ops!',
                            detail: this.error,
                            life: 10000
                        });
            }
        },
        onHide() {
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            if(['id'].indexOf(this.params.sort.field)>= 0){
                params.push(`order[cont.${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));

            }
            else{
                params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            }

            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Conta.listContas(this.contas.join(), params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onClearBusca(event) {
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        }
    }
}
</script>
